export const LineDivider = () => {
  return <hr className="h-[4px] bg-gray-600 my-2" />;
};
